import ProjectListService from 'services/api/project-list/projectListService';

export const createMap = (arra: any[], key: string) => {
  return arra?.reduce((acc, curr) => {
    acc[curr[key]] = curr;
    return acc;
  }, {});
};

export const anyIndustryValue = async () => {
  const response = await ProjectListService.getIndustries('A');
  return response.industries.filter((industry) => industry.externalId == '-1');
};
